module.exports = __webpack_public_path__ + "img/reckoner.a14cce2.svg";